/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RedeemNftRewardBody
 */
export interface RedeemNftRewardBody {
    /**
     * 
     * @type {string}
     * @memberof RedeemNftRewardBody
     */
    transactionHash?: string;
    /**
     * 
     * @type {string}
     * @memberof RedeemNftRewardBody
     */
    nftOwnershipId: string;
}

/**
 * Check if a given object implements the RedeemNftRewardBody interface.
 */
export function instanceOfRedeemNftRewardBody(value: object): value is RedeemNftRewardBody {
    if (!('nftOwnershipId' in value) || value['nftOwnershipId'] === undefined) return false;
    return true;
}

export function RedeemNftRewardBodyFromJSON(json: any): RedeemNftRewardBody {
    return RedeemNftRewardBodyFromJSONTyped(json, false);
}

export function RedeemNftRewardBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedeemNftRewardBody {
    if (json == null) {
        return json;
    }
    return {
        
        'transactionHash': json['transactionHash'] == null ? undefined : json['transactionHash'],
        'nftOwnershipId': json['nftOwnershipId'],
    };
}

export function RedeemNftRewardBodyToJSON(json: any): RedeemNftRewardBody {
    return RedeemNftRewardBodyToJSONTyped(json, false);
}

export function RedeemNftRewardBodyToJSONTyped(value?: RedeemNftRewardBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactionHash': value['transactionHash'],
        'nftOwnershipId': value['nftOwnershipId'],
    };
}

